export const formatNumber = (number) => {
  if (!number && number !== 0) return "0";
  return number.toString();
};

export const formatDealerPercentage = (dealers) => {
  if (!dealers) return "";
  return dealers
    .map(
      (dealer) =>
        `• ${dealer.name}\n  ${dealer.vehicles} vehículos - ${dealer.percentage}%`
    )
    .join("\n");
};

export const getProvincePercentage = (
  province,
  provinceStats,
  totalVehicles
) => {
  if (totalVehicles === 0) return 0;
  const provinceStat = provinceStats.find(
    (stat) => stat.day_province === province
  );
  if (!provinceStat) return 0;
  return (
    (parseInt(provinceStat.total_vehicles) / totalVehicles) *
    100
  ).toFixed(0);
};

export const getCantonPercentage = (canton, totalProvincial) => {
  if (!totalProvincial || totalProvincial === 0) return 0;
  const cantonVehicles = parseInt(canton.total_vehicles || 0);
  return ((cantonVehicles / totalProvincial) * 100).toFixed(0);
};

export const getParishPercentage = (parishVehicles, cantonTotal) => {
  if (!cantonTotal || cantonTotal === 0) return 0;
  return ((parseInt(parishVehicles) / parseInt(cantonTotal)) * 100).toFixed(0);
};
